import * as React from 'react';
import { getSearchTerm } from 'app/pages/DiscountsList/modules/DiscountItemsList';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { changeSearchTerm } from 'app/pages/DiscountsList/actions';
import { Action } from 'app/pages/DiscountsList/actionTypes';
import GenericSearchWidget from 'app/shared/ui/GenericSearchWidget'

interface SearchWidgetProps {

}

interface StateProps {
    searchTerm: string
}

interface DispatchProps {
    changeSearchTerm: (value: string) => void
}

const mapStateToProps = (state:any, ownProps: SearchWidgetProps) : StateProps => {
    return {
        searchTerm: getSearchTerm(state)
    };
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>) : DispatchProps => ({
    changeSearchTerm: (term: string) => dispatch(changeSearchTerm(term))
});

export default connect(mapStateToProps, mapDispatchToProps)(GenericSearchWidget);